import { SET_SPAM_INTEREST_SIDE_MENU_LOADING } from "./types";

export const setSpamInterestSideMenuLoading = () => (dispatch) => {
  dispatch({
    type: SET_SPAM_INTEREST_SIDE_MENU_LOADING,
    payload: {},
  });
};